import request from '@/utils/request'

export function getLatestNews(params) {
  return request({
    url: '/api/sns',
    method: 'GET',
    params,
  })
}

export function getLatestNewsDetail(id) {
  return request({
    url: `/api/sns/${id}`,
    method: 'GET',
  })
}

export function createLatestNews(data) {
  return request({
    url: '/api/sns',
    method: 'POST',
    data
  })
}

export function editLatestNews(id, data) {
  return request({
    url: `/api/sns/${id}`,
    method: 'PUT',
    data
  })
}

